import { createSelector } from 'reselect';

import { getSystem } from './system.selectors';

export const selectTimedSequenceSchema = createSelector(
  getSystem,
  ({ timedSequenceSchema }) => timedSequenceSchema,
);
